module.exports = __webpack_public_path__ + "static/media/performer.1401c100.jpg";